import { useState } from 'react';
import { BoardQuery } from '@api/Trinium/types';
import { dispatchFilterMaps } from '@components/Filters/dispatchFilterMaps';
import { operatorMaps } from '@components/Filters/operatorMaps';
import { useFetchDispatchLegsQuery } from '@api/Trinium/Endpoints/Dispatch/slice';
import useDebouncer from '@hooks/useDebounce';

import styles from './QuerySelector.module.css';

export function QueryWithCount(props: { query: BoardQuery; terminalNumber: string }) {
	const [filteredLegs, setFilteredLegs] = useState<undefined | number>();

	const { dispatchLegs } = useFetchDispatchLegsQuery(props.terminalNumber, {
		selectFromResult: ({ data }) => ({
			dispatchLegs: data
		})
	});

	useDebouncer(
		() => {
			setFilteredLegs(
				new Set(
					props.query.configuration.filters.reduce((filteredData, filter) => {
						const filterMap = dispatchFilterMaps[filter.map];
						return filteredData?.filter((leg) =>
							operatorMaps[filter.operator](leg, filterMap.fields, filterMap.fieldType, filter.value, filterMap.fieldProperty)
						);
					}, dispatchLegs)
				).size
			);
		},
		// The filters rather than props, which is a fresh object on every parent render and recounts every query with it
		[dispatchLegs, props.query.configuration.filters],
		100
	);

	return (
		<>
			<span className={styles.title}>{props.query.name}</span>
			<div className={styles.count}>{filteredLegs ?? '-'}</div>
		</>
	);
}
